import React from 'react';
export function SprintPlanSection() {
  const weeks = [{
    week: 'WEEK 1',
    title: 'Infrastructure Build',
    description: "We define your stack, build your 'Ghost Portfolio,' and automate the core 'Content Pillar.'"
  }, {
    week: 'WEEK 2',
    title: 'The Lead Torrent',
    description: "We scrape the high-value leads and launch the 'Reverse Offer' via LinkedIn."
  }, {
    week: 'WEEK 3',
    title: 'Closing the First $2k',
    description: "We pitch the automated engine, handle the 'Is it just AI?' objection, and send the first invoice."
  }, {
    week: 'WEEK 4',
    title: 'Scaling & Optimization',
    description: 'We automate the referral loop and evaluate for scale. If Profit > $5k and Time < 10h/week... we pour fuel on the fire.'
  }];
  return <section className="py-14 bg-dark-900 relative border-t border-cyan-900/30" data-id="element-648">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-649">
        <div className="text-center mb-10" data-id="element-650">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-651">
            The 30-Day Execution Plan <br data-id="element-652" />
            <span className="text-cyan-400 text-glow" data-id="element-653">(The Sprint)</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-654">
            The "Engine" doesn't just produce content. It produces Life. Here is
            exactly how we build it together:
          </p>
        </div>

        <div className="relative" data-id="element-655">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-cyan-900/50 md:-translate-x-1/2" data-id="element-656"></div>

          <div className="space-y-8 relative" data-id="element-657">
            {weeks.map((week, index) => <div key={index} className={`relative flex flex-col md:flex-row gap-8 items-start ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-658">
                {/* Timeline Dot */}
                <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-cyan-400 rounded-full -translate-x-[5px] md:-translate-x-1/2 mt-6 shadow-[0_0_10px_rgba(0,240,255,0.8)]" data-id="element-659"></div>

                <div className="w-full md:w-1/2 pl-12 md:pl-0" data-id="element-660">
                  <div className={`bg-dark-950 border border-cyan-900/30 p-6 rounded-xl hover:border-cyan-500/40 transition-colors ${index % 2 === 0 ? 'md:ml-12' : 'md:mr-12'}`} data-id="element-661">
                    <div className="text-cyan-500 font-mono text-sm font-bold mb-2 tracking-wider" data-id="element-662">
                      {week.week}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-3" data-id="element-663">
                      {week.title}
                    </h3>
                    <p className="text-gray-400" data-id="element-664">{week.description}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}